import "./buttons.scss";

import { triggerCommunityRegistrationView } from "../../helpers/observability/analytics";
import { useFormFlowContext } from "../forms/FormFlowContext";

const NeedMoreHelp = ({ from }) => {
  const { setView } = useFormFlowContext();
  const sendAnalyticsNeedHelp = () => {
    triggerCommunityRegistrationView({
      "event_action": "send_one-time_login_email",
      "event_label": "need_more_help",
    });
  }

  return (
    <button
      className="btn-text-blue base navigate p-0 text-align-start width-fit"
      onClick={() => {setView(`login_issues__${from}`); sendAnalyticsNeedHelp();}}>
      <strong>Need more help?</strong>
    </button>
  );
};

export default NeedMoreHelp;
